// The dashboard's short Receipts list: the latest few, with Open and Send.
import { usd, shortDate } from './money';

export default function RecentReceipts({ rows, onOpen, onSend, busy = false }) {
  return (
    <table className="rc-table rc-recent">
      <tbody>{rows.map((r) => (
        <tr key={r.id}>
          <td>
            <strong>{r.merchant || 'Merchant not read'}</strong>{' '}
            <span className="rc-nowrap" style={{ color: '#7a6a5a' }}>{shortDate(r.purchaseDate)}{r.person ? ` · ${r.person}` : ''}</span>
            {r.matchStatus === 'linked' && <span className="rc-chip rc-chip--ok" style={{ cursor: 'default' }}>✓</span>}
          </td>
          <td className="num"><strong>{usd(r.total)}</strong></td>
          <td className="num">
            <span className="rc-row-actions">
              <button className="rc-anchor" onClick={() => onOpen(r.id)}>Open</button>
              <button className="rc-btn rc-btn--small" disabled={busy} onClick={() => onSend([r.id])}>Send</button>
            </span>
          </td>
        </tr>
      ))}</tbody>
    </table>
  );
}
